<template>
  <div class="SectionPersonelSearchPanel">
    <div class="px-3 pt-2">
      <v-row>
        <v-col>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>
                    <label for="personelByName"
                      >{{ $t("personelByName") }}:
                    </label>
                  </td>
                  <td>
                    <div>
                      <v-select
                        hide-details
                        v-model="personel"
                        :items="personelList"
                        :label="$t('personelByName')"
                        item-text="PersonName"
                        item-value="PERNO"
                        return-object
                        dense
                        solo
                        v-on:change="changePersonelByName"
                        class="my-auto py-0"
                      ></v-select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label for="personelByPerno"
                      >{{ $t("personelByPerno") }}:
                    </label>
                  </td>
                  <td>
                    <div>
                      <v-text-field
                        hide-details
                        v-model.lazy="personelPerno"
                        :label="$t('personelByPerno')"
                        @change="changePersonelPerno"
                        dense
                        solo
                        class="my-auto py-0"
                      ></v-text-field>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="my-auto">{{ $t("newPass") }} :</td>
                  <td>
                    <v-text-field
                      solo
                      :label="$t('newPass')"
                      v-model.lazy="newPass"
                      dense
                      hide-details=""
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td class="my-auto">{{ $t("confirmNewPass") }} :</td>
                  <td>
                    <v-text-field
                      solo
                      :label="$t('confirmNewPass')"
                      dense
                      hide-details=""
                      v-model.lazy="confirmPass"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ResultType from "../../../model/ResultType";
export default {
  props: {
    accessTo: Number,
  },
  components: {},
  data() {
    return {
      personelList: [],
      personel: {},
      personelPerno: "",
      password: "",
      newPass: "",
      confirmPass: "",
    };
  },
  mounted() {
    this.getPersonelList();
  },
  watch: {
    newPass(){
      this.search();
    },
    confirmPass() {
      this.search();
    },
  },
  methods: {
    getPersonelList() {
      var permissionNumber = this.accessTo;
      this.$store
        .dispatch("GetAccessPersonList", { permissionNumber })
        .then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.personelList = result.data;
            if (this.personelList.length > 0) {
              this.personel = this.personelList[0];
              this.personelPerno = this.personel.PerNo.trim();
              this.search();
            }
          }
        });
    },

    changePersonelByName() {
      this.personelPerno = this.personel.PerNo.trim();
      this.search();
    },
    changePersonelPerno() {
      var personel = this.personelList.find(
        (item) => item.PerNo.trim() == this.personelPerno
      );
      if (personel) {
        this.personel = personel;
      } else {
        this.personel = "";
      }
      this.search();
    },
    search() {
      var perno = "-1";
      if (this.personel && this.personel?.PerNo.trim()) {
        perno = this.personel?.PerNo.trim();
      } else if (this.personelPerno) {
        perno = this.personelPerno;
      }

      var searchParams = {
        perno: perno,
        newPass: this.newPass,
        confirmPass: this.confirmPass,
      };
      //debugger
      if(this.personel==""||this.personel==0){
        searchParams.perno=""
      }

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>